export default "__VITE_ASSET__CETh2cBo__"